import { Link } from '@tanstack/react-router';

interface LogoProps {
  showLabels?: boolean;
}

const Logo = ({ showLabels }: LogoProps) => {
  return (
    <div className="flex h-[85px] items-end gap-2 overflow-hidden pb-3">
      <Link to="/users" className="relative w-[125px] shrink-0">
        <img src="/images/logos/logo.png" alt="logo" />
      </Link>
      {showLabels && (
        <>
          <span className="text-xl font-normal text-gray-900">Admin</span>
          <span className="text-brand-blue rounded-lg bg-blue-50 px-2.5 py-1 text-sm font-medium">
            Mobile
          </span>
        </>
      )}
    </div>
  );
};

export default Logo;
